import { put, call, take, fork } from 'redux-saga/effects'
import { cardSelectionDeleteService } from '../../api/card'
import { cardSelectionDeleteSuccess } from '../../reducers/card/action'
import { CARD_SELECTION_DELETE } from '../../reducers/card/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* cardSelectionDeleteFlow(payload) {
  try {
    const { id, questionId, callback } = payload
    yield call(cardSelectionDeleteService, id)

    yield put(cardSelectionDeleteSuccess(id, questionId))
    yield put(operationSuccess())

    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* cardSelectionDeleteWatcher() {
  while (true) {
    const action = yield take(CARD_SELECTION_DELETE)
    const { payload } = action

    yield fork(generalSaga, cardSelectionDeleteFlow, payload)
  }
}
